module.exports = __webpack_public_path__ + "assets/c7f941f3d0aa31b982a7466dfc2e1902.mp3";